import { Field } from 'formik';
import { Link } from 'react-router-dom';
import PmsUrlConfig from '../../urlConfig.js';


export default function LoginForm ({errors, touched, passwordType, togglePassword, isSubmitting, handleReset})  {
    return (
        <>
            <div className="mb-6">
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <Field type="text" name="username" data-testid='username'
                    className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent ${
                        errors.username ? 'border-red-500 bg-red-50' : 'border-gray-300'
                    }`}
                    placeholder="Enter your email" />
                {errors.username && touched.username ? (
                    <div className="mt-1 text-sm text-red-600">{errors.username}</div>
                ) : null}
            </div>
            <div className="mb-6">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">Password</label>
                <div className="relative">
                    <Field name="password" data-testid='password'
                        type={passwordType}
                        className={`w-full px-3 py-2 pr-10 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent ${
                            errors.password && touched.password ? 'border-red-500 bg-red-50' : 'border-gray-300'
                        }`}
                        placeholder="Enter your password" />
                    <button type="button" onClick={togglePassword} className="absolute inset-y-0 right-0 pr-3 flex items-center outline-none">
                        {passwordType === "password" ?
                            <i className="fas fa-eye text-gray-400 hover:text-gray-600"></i>
                            :
                            <i className="fas fa-eye-slash text-gray-400 hover:text-gray-600"></i>
                        }
                    </button>
                </div>
                {errors.password && touched.password ? (
                    <div className="mt-1 text-sm text-red-600">{errors.password}</div>
                ) : null}
            </div>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mb-6">
                <button className="flex-1 px-6 py-2 bg-teal-700 text-white font-medium rounded-md hover:bg-teal-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2" type="submit" disabled={isSubmitting}>
                    {isSubmitting ? "Logging In..." : "Login"}
                </button>
                <button className="flex-1 px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-md hover:bg-gray-300 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2" type="button" onClick={handleReset}>Reset</button>
            </div>
            <div className="text-center">
                <p className="text-gray-600">
                    Don't have an account?{' '}
                    <Link to={`${PmsUrlConfig.SIGN_UP_URL}`} className="text-teal-600 hover:text-teal-700 font-medium transition-colors">Register</Link>
                </p>
            </div>
            <div className="text-center mt-4">
                <Link to={`${PmsUrlConfig.FORGOT_PASSWORD_URL}`} className="text-teal-600 hover:text-teal-700 font-medium transition-colors">Forgot Password</Link>
            </div>
        </>
    )
}